/**
 * Centralized constants for all MCP connector identifiers
 * Keep this in sync with C# ConnectorIds class
 */
export const ConnectorIds = {
    /** Dropbox file storage connector */
    Dropbox: 'connector_dropbox',

    /** Gmail email connector */
    Gmail: 'connector_gmail',

    /** Google Calendar connector */
    GoogleCalendar: 'connector_googlecalendar',

    /** Google Drive file storage connector */
    GoogleDrive: 'connector_googledrive',

    /** Microsoft Teams connector */
    MicrosoftTeams: 'connector_microsoftteams',

    /** Outlook Calendar connector */
    OutlookCalendar: 'connector_outlookcalendar',

    /** Outlook Email connector */
    OutlookEmail: 'connector_outlookemail',

    /** SharePoint document connector */
    SharePoint: 'connector_sharepoint'
} as const;

/**
 * Array of all valid connector IDs for validation purposes
 */
export const ALL_CONNECTOR_IDS = Object.values(ConnectorIds);

/**
 * Set of all valid connector IDs for efficient lookups
 */
export const VALID_CONNECTOR_IDS = new Set(ALL_CONNECTOR_IDS);

/**
 * Type representing all valid connector ID values
 */
export type ConnectorId = (typeof ConnectorIds)[keyof typeof ConnectorIds];
